/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.29.4-beta.0.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { exists } from '../runtime';
export function ProblemDetailsFromJSON(json) {
    return ProblemDetailsFromJSONTyped(json, false);
}
export function ProblemDetailsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return __assign(__assign({}, json), { 'type': !exists(json, 'type') ? undefined : json['type'], 'title': !exists(json, 'title') ? undefined : json['title'], 'status': !exists(json, 'status') ? undefined : json['status'], 'detail': !exists(json, 'detail') ? undefined : json['detail'], 'instance': !exists(json, 'instance') ? undefined : json['instance'] });
}
export function ProblemDetailsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return __assign(__assign({}, value), { 'type': value.type, 'title': value.title, 'status': value.status, 'detail': value.detail, 'instance': value.instance });
}
